import { useStores } from 'Hooks/useStore';
import { useCallback } from 'react';
import { PermissionProps } from './Permission';
import { hasPermission } from './Permission.helpers';

export const usePermission = () => {
	const {
		authStore: { currentUserPermissionCodes, isCurrentUserSuperAdmin },
		systemsStore: { featureList }
	} = useStores();

	const getHasPermission = useCallback(
		(props: Omit<PermissionProps, 'children'>) => {
			const disableCheck = featureList.length === 0;
			if(!isCurrentUserSuperAdmin && disableCheck && props.code) {
				return {
					permitted: true,
					permittedByCode: {}
				}
			}
			return hasPermission({
				permission: props,
				currentPermissionCodes: currentUserPermissionCodes
			});
		},
		[currentUserPermissionCodes, featureList]
	);

	return {
		getHasPermission
	};
};
